import React from "react";
import PageTitle from "../../../components/Common/PageTitle";
import { Box, Grid2, Stack, Typography, useTheme } from "@mui/material";
import ContentCard from "../../../components/Content/ContentCard";
import { networkingData } from "../../../assets/data/data";
import { NorthEast } from "@mui/icons-material";

const Networking = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageTitle
        title={"IGE Networking Groups"}
        text={
          "<b>IGE</b> stands for <b>Individual and Group Excellence</b>, providing a collaborative space where individuals with unique skillsets come together to help one another thrive. Through a community of students, practitioners, supervisors, and instructors, IGE offers various levels of support to help you achieve personal and professional success."
        }
        noIcon
      />

      <Grid2 container spacing={2} sx={{ mt: 4 }}>
        {networkingData.map((item, index) => (
          <>
            <ContentCard key={item.id} item={item} height={"225px"} />

            {index === 2 && (
              <Grid2 item size={{ xs: 12 }}>
                <Typography
                  sx={{
                    fontFamily: "'Quicksand', sans-serif",
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: theme.palette.text.primary,
                  }}
                >
                  Features of IGE Business Networking:
                </Typography>
              </Grid2>
            )}
          </>
        ))}
      </Grid2>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 2,
          p: 4,
          border: `0.25px solid ${theme.palette.text.primary}`,
        }}
      >
        <Stack direction={"column"} alignItems={"flex-start"}>
          <Typography sx={theme.heading2}>Why Join IGE Networking?</Typography>
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontFamily: "'Quicksand', sans-serif",
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "18px",
            }}
          >
            IGE Business Networking Groups create a nurturing environment for
            professionals to grow their businesses, expand their networks, and
            develop essential skills.
          </Typography>
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontFamily: "'Quicksand', sans-serif",
              fontSize: "16px",
            }}
          >
            Join a community dedicated to fostering excellence, collaboration,
            and mutual success.
          </Typography>
        </Stack>
        <NorthEast
          sx={{ fontSize: "24px", color: theme.palette.text.primary }}
        />
      </Box>
    </Box>
  );
};

export default Networking;
